module.exports = __webpack_public_path__ + "img/pa.ee292674.svg";